<template>
  <navbar
    navbar-menu-classes="navbar-right"
    v-model="showMenu"
    style="border-bottom:0"
    type="default"
  >
    <div class="navbar-wrapper">
      <a
        class="navbar-brand"
        href="/"
      >Two Beads</a>
    </div>
    <template v-slot:navbar-menu>
      <ul class="navbar-nav">
        <router-link
          to="/login"
          class="nav-item"
          tag="li"
          @click.native="toggleShow"
        >
          <a class="nav-link">
            <i class="nc-icon nc-tap-01" /> Login
          </a>
        </router-link>
        <router-link
          to="/invitation"
          class="nav-item"
          tag="li"
          @click.native="toggleShow"
        >
          <a class="nav-link">
            <i class="nc-icon nc-book-bookmark" /> Accept Invitation
          </a>
        </router-link>
        <router-link
          to="/create-course"
          class="nav-item"
          tag="li"
          @click.native="toggleShow"
        >
          <a class="nav-link">
            <i class="nc-icon nc-album-2" /> New Course
          </a>
        </router-link>
      </ul>
    </template>
  </navbar>
</template>

<script>
import Navbar from '@/plugins/paper-components/navbar/navbar.vue'
export default {
  name: 'MainHeader',
  components: {
    Navbar
  },
  data: function () {
    return {
      showMenu: false
    }
  },
  methods: {
    toggleShow: function () {
      this.showMenu = false
    }
  }
}
</script>
<style scoped>
  .navbar .navbar-nav .nav-item.active .nav-link:not(.btn),
  .navbar .navbar-nav .nav-item .nav-link:not(.btn):focus,
  .navbar .navbar-nav .nav-item .nav-link:not(.btn):hover,
  .navbar .navbar-nav .nav-item .nav-link:not(.btn):active {
    color: #51bcda;
  }
</style>
